import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@mui/material/styles";
import { AuthProvider } from "contexts/AuthContext";
import { RunsProvider } from "contexts/RunsContext";
import { SimulationsProvider } from "contexts/SimulationsContext";
import { MapStateProvider } from "contexts/MapStateContext";
import { SnackbarProvider } from "notistack";
import { theme } from "theme";

const queryClient = new QueryClient();

export default function AppProviders({ children }) {
  return (
    <SnackbarProvider autoHideDuration={3000}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <AuthProvider>
            <RunsProvider>
              <SimulationsProvider>
                <MapStateProvider>{children}</MapStateProvider>
              </SimulationsProvider>
            </RunsProvider>
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </SnackbarProvider>
  );
}
